// src/components/MainLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppBarSidebar from '../components/layout/AppBarSidebar';

const MainLayout = () => {
  return (
    <>
      <AppBarSidebar />
      <Outlet />
    </>
  );
};

export default MainLayout;
